
import { Component, Vue, Prop } from 'vue-property-decorator';
import LinkableLabel from '../shared/LinkableLabel.vue';
import { Utils } from '../Utils';

@Component({
    components: {
        LinkableLabel,
    },
})
export default class InputRow extends Vue {
    @Prop({ default: true }) isVisible!: boolean;

    // label props
    @Prop() labelId!: string;
    @Prop() inputId!: string;
    @Prop() labelText!: string;
    @Prop({ default: false }) hasLink!: boolean;
    @Prop() popoverType!: string;

    //input props
    @Prop() value!: string;
    @Prop() isRequired!: boolean;
    @Prop() errorMessage!: string;

    @Prop({ default: 'string' }) inputType!: string;
    @Prop() formatNumberOfDecimalsTo!: number;
    @Prop() minValue!: number;
    @Prop() maxValue!: number;

    @Prop({ default: '' }) glyphSymbol!: string;
    @Prop() glyphAlign!: string;
    @Prop() glyphAriaDescription!: string;

    isInvalid = false;
    alertId = '';
    cyAlertId = '';

    created() {
        this.alertId = this.inputId + '-alert';
        this.cyAlertId = this.inputId + '-alert-cy';
    }

    mounted() {
        this.$root.$on('resetFields', () => {
            this.isInvalid = false;
        });
    }

    get iconAlign() {
        let alignValue = '';
        if (this.glyphAlign && this.glyphSymbol.length > 0) {
            switch (this.glyphAlign.toLowerCase()) {
                case 'right':
                    alignValue = 'icon-right';
                    break;
                case 'left':
                    alignValue = 'icon-left';
                    break;
            }
        }
        return alignValue;
    }

    handleFocus() {
        this.isInvalid = false;
    }

    handleInput(e: any) {
        if (Utils.hasDecimal(e.target.value) && Utils.isDecimalKeyPressed(e)) {
            e.preventDefault();
        }
        if (this.formatNumberOfDecimalsTo == 0 && Utils.isDecimalKeyPressed(e)) {
            e.preventDefault();
        }

        Utils.handleNumberInput(e);
    }

    onPaste(e: any) {
        // check if the copied paste is valid
        if (!(e.clipboardData.getData('text').match(/^\d+(\.\d{1,})?$/))) {
            e.preventDefault();
        }
    }

    handleInputValidation() {
        if ( this.minValue != undefined && parseFloat(this.value) < this.minValue) {
            this.isInvalid = true;
        }

        if ( this.maxValue != undefined && parseFloat(this.value) > this.maxValue) {
            this.isInvalid = true;
        }
    }

    handleValueChange(event: any) {
        this.isInvalid = false;

        let val = event.target.value ? event.target.value.trim() : '';
        if (
            this.inputType === 'decimal' &&
            this.formatNumberOfDecimalsTo !== undefined &&
            val !== ''
        ) {
            val = parseFloat(event.target.value).toFixed(
                this.formatNumberOfDecimalsTo
            );
        }
 
        if ( this.minValue != undefined && val < this.minValue ) {
            this.isInvalid = true;
        }

        if ( this.maxValue != undefined && val > this.maxValue ) {
            this.isInvalid = true;
        }

        
        // This is required to make v-model attribute work for child components
        // when they are defined in the parent component.
        this.$emit('input', val);

        // This is used when the parent component needs to take action, such
        // as validation, when the child component value is updated.
        this.$emit('valueChange', val);
    }

    // called when form validation happens and there is an error
    handleInvalid() {
        this.isInvalid = true;
    }
}
